function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "face");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "face",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8,1 L12.8,2.2 C12.8,2.75228475 12.3522847,3.2 11.8,3.2 L10.4,3.2 L10.4,3.2 C9.848,3.2 9.6,3.848 9.6,4.4 L9.6,6.4 L11,6.4 C11.5522847,6.4 12,6.84771525 12,7.4 L12,8.6 C12,9.15228475 11.5522847,9.6 11,9.6 L9.6,9.6 L9.6,9.6 L9.6,15 C9.6,15.5522847 9.15228475,16 8.6,16 L7.4,16 C6.84771525,16 6.4,15.5522847 6.4,15 L6.4,9.6 L6.4,9.6 L5,9.6 C4.44771525,9.6 4,9.15228475 4,8.6 L4,7.4 C4,6.84771525 4.44771525,6.4 5,6.4 L6.4,6.4 L6.4,6.4 L6.4,3.2 C6.4,1.4326888 7.8326888,0 9.6,0 L11.8,0 C12.3522847,-1.01453063e-16 12.8,0.44771525 12.8,1 Z",
  id: "icon/social/facebook_24px",
  fill: "#ffffff",
  fillRule: "nonzero"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.15e5952f.svg";
export { ForwardRef as ReactComponent };